import {
  MdOutlineSpaceDashboard,
  MdContactPhone,
  MdSettings,
  MdOutlinePassword,
  MdOutlineSavings,
} from "react-icons/md";
import { BiSolidBookContent, BiLogoProductHunt } from "react-icons/bi";
import {
  FaRegUser,
  FaUsers,
  FaFirstOrder,
  FaUserEdit,
  FaCartPlus,
} from "react-icons/fa";
import { AiOutlineProduct } from "react-icons/ai";
import { TbBrandGoogleAnalytics, TbHelpSquare } from "react-icons/tb";
import { CiDeliveryTruck } from "react-icons/ci";
export const sidebarItems = [
  {
    id: 1,
    title: "Dashbaord",
    link: "/dashboard",
    icon: <MdOutlineSpaceDashboard size={"1.2rem"} />,
  },
  {
    id: 2,
    title: "Manage Content",
    icon: <BiSolidBookContent size={"1.2rem"} />,
    sublinks: [
      {
        id: 1,
        title: "Manage Pages",
        link: "/dashboard/pages",
      },
      {
        id: 2,
        title: "Manage Testimonial",
        link: "/dashboard/testimonial",
      },
    ],
  },
  {
    id: 3,
    title: "Manage Inquiries",
    icon: <MdContactPhone size={"1.2rem"} />,
    sublinks: [
      {
        id: 1,
        title: "Contact Inquiries",
        link: "/dashboard/contact",
      },
      {
        id: 2,
        title: "Faqs Inquiries",
        link: "/dashboard/faqs",
      },
      {
        id: 3,
        title: "Subscribed Users",
        link: "/dashboard/subscribe",
      },
    ],
  },
  // {
  //   id: 4,
  //   title: "Manage Products",
  //   icon: <BiLogoProductHunt size={"1.2rem"} />,
  //   sublinks: [
  //     {
  //       id: 1,
  //       title: "Categories",
  //       link: "/dashboard/categories",
  //     },
  //     {
  //       id: 2,
  //       title: "Add Products",
  //       link: "/dashboard/create-products",
  //     },
  //     {
  //       id: 3,
  //       title: "All Products",
  //       link: "/dashboard/products",
  //     },
  //   ],
  // },
  {
    id: 4,
    title: "User Management",
    icon: <FaUsers size={"1.2rem"} />,
    sublinks: [
      {
        id: 1,
        title: "Users",
        link: "/dashboard/users",
      },
    ],
  },
  {
    id: 5,
    title: "Vendors",
    link: "/dashboard/vendors",
    icon: <AiOutlineProduct size={"1.2rem"} />,
  },
  // {
  //   id: 6,
  //   title: "Manage Orders",
  //   icon: <FaFirstOrder size={"1.2rem"} />,
  //   sublinks: [
  //     {
  //       id: 1,
  //       title: "Orders",
  //       link: "/dashboard/orders",
  //     },
  //   ],
  // },
  // {
  //   id: 7,
  //   title: "General Settings",
  //   link: "/settings",
  //   icon: <MdSettings size={"1.2rem"} />,
  // },
];

export const userProfile = [
  {
    id: 1,
    title: "Profile",
    link: "/profile",
    icon: <FaRegUser size={"1.2rem"} />,
  },
  {
    id: 2,
    title: "Reset Password",
    link: "/reset-password",
    icon: <MdOutlinePassword size={"1.2rem"} />,
  },
  {
    id: 3,
    title: "Settings",
    link: "/settings",
    icon: <MdSettings size={"1.2rem"} />,
  },
  {
    id: 4,
    title: "Edit Profile",
    link: "/edit-profile",
    icon: <FaUserEdit size={"1.2rem"} />,
  },
  {
    id: 5,
    title: "Analysis & Data",
    link: "/data-analysis",
    icon: <TbBrandGoogleAnalytics size={"1.2rem"} />,
  },
  {
    id: 4,
    title: "Help Center",
    link: "/help",
    icon: <TbHelpSquare size={"1.2rem"} />,
  },
];

export const total = [
  {
    id: 1,
    title: "Total Revenue",
    icon: <MdOutlineSavings size={"1.5rem"} />,
    amount: "$82,650",
    grow: "up",
    percentage: "20%",
  },
  {
    id: 2,
    title: "Total Order",
    icon: <FaCartPlus size={"1.5rem"} />,
    amount: "12,10",
    grow: "up",
    percentage: "20%",
  },
  {
    id: 3,
    title: "Total Customer",
    icon: <FaRegUser size={"1.5rem"} />,
    amount: "12,64",
    grow: "down",
    percentage: "20%",
  },
  {
    id: 4,
    title: "Pending Delivery",
    icon: <CiDeliveryTruck size={"1.5rem"} />,
    amount: "16,45",
    grow: "up",
    percentage: "10%",
  },
];
